<app-scroll-top></app-scroll-top>
<div class="mention-legales-bloc">
  <div class="container content">
    <div id="accordion">
      <div class="py-5">
        <div class="text-uppercase py-3">
          <h3>MENTIONS LÉGALES</h3>
        </div>
        <div ngbAccordion>
          <div ngbAccordionItem>
            <h4 ngbAccordionHeader>
              <button ngbAccordionButton>Crédits</button>
            </h4>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
            <ng-template>
              <div>
                <p> Le site Internet www.thedoorman.immo (ci-après le "Site") vous est fourni par :</p>
                <div class="center">
                  <p><strong>THE DOOR MAN France</strong>,
                    <br/>SASU au capital de 1000 euros, dont le siège social est situé 3 bis rue Barthélémy Thimonnier
                    78120 Rambouillet, RCS 828 180 430 , titulaire de la carte professionnelle Transactions sur immeubles et fonds de commerce n° CPI
                    9201 2017 000 018 666 délivrée par la CCI PARIS IDF, assurée en responsabilité civile
                    professionnelle par GALIAN-SMABTP dont le siège est sis 89, rue la Boétie 75008 Paris, sous le n°
                    RCP_01_120290A, adhérente de la caisse de Garantie GALIAN-SMABTP dont le siège est sis 89, rue la
                    Boétie 75008 Paris sous le n° B 720 151 69 pour un montant de 120 000 euros, TVA intracommunautaire
                    : FR83828180430 - Code APE : 6831 Z.</p>
                  <p>Représenté par son Président <strong>Pierre-Etienne BEUVELET</strong></p>


                  <p>Création graphique, intégration et développement : </p>
                  <div class="center">
                    <p><strong>HORUS TECHNOLOGIES</strong><br>3 bis, rue Barthélemy Thimonnier<br>
                      78120 RAMBOUILLET FRANCE</p>
                  </div>
                  <p>Enregistrée au Registre du Commerce et des Sociétés, sous le numéro 452 236 904
                  </p>
                  <p> Hébergeur du Site : <strong>OVH</strong></p>
                </div>
              </div>
            </ng-template>
              </div>
            </div>
          </div>
          <div ngbAccordionItem>
            <h4 ngbAccordionHeader>
              <button ngbAccordionButton>Accès et utilisation</button>
            </h4>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
            <ng-template>
              <div>
                <p>Par votre accès et votre utilisation du Site, vous acceptez sans réserve de vous
                  conformer aux termes<br> et conditions définis ci-après, et qui s'appliquent dès
                  votre première connexion au Site.
                  <span class="blue-text"><strong>THE DOOR MAN</strong> </span>se réserve la
                  possibilité de modifier ces termes et conditions à tout moment.<br> Les
                  modifications prendront effet dès leur publication en ligne.
                </p>
              </div>
            </ng-template>
              </div>
            </div>
          </div>
          <div ngbAccordionItem>
            <h4 ngbAccordionHeader>
              <button ngbAccordionButton>Propriété intellectuelle</button>
            </h4>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
            <ng-template>
              <div>
                <p>La connexion au Site vous confère le droit d'utiliser ses fonctionnalités et contenus
                  de façon privée et non-exclusive.
                  Les noms, images et logos contenus dans le site sont protégés par droits d'auteurs,
                  dessins et modèles ou marques déposées de <span class="blue-text"><strong>THE DOOR
                                            MAN</strong></span>. En aucun cas l'accès au Site ne confère un droit ou une
                  licence, implicite
                  ou explicite, d'utilisation des marques, dessins et modèles ou droits d'auteurs
                  détenus par <span class="blue-text"><strong>THE DOOR MAN</strong></span>.
                  Les droits d'auteurs relatifs aux textes, images et tous autres éléments représentés
                  sur le Site sont la propriété exclusive de <span class="blue-text"><strong>THE DOOR
                                            MAN</strong></span>, ou ont été intégrés avec l'autorisation des titulaires
                  de ces droits.
                  Toute reproduction, totale ou partielle, et par quelque moyen que ce soit est
                  formellement interdite, sauf accord préalable et écrit de <span
                    class="blue-text"><strong>THE DOOR MAN</strong></span>.
                  Les marques et logos de <span class="blue-text"><strong>THE DOOR MAN</strong>
                                    </span> représentés sur le Site sont des marques déposées dans le monde entier et
                  protégées par les lois relatives à la propriété intellectuelle.
                  Toute reproduction ou utilisation de ces marques sans accord préalable et écrit de
                  <span class="blue-text"><strong>THE DOOR MAN</strong> </span> constitue un acte de
                  contrefaçon et fera l'objet de poursuites judiciaires.
                </p>
              </div>
            </ng-template>
              </div>
            </div>
          </div>
          <div ngbAccordionItem>
            <h4 ngbAccordionHeader>
              <button ngbAccordionButton>Garanties</button>
            </h4>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
            <ng-template>
              <div>
                <p>Garantie et RCP GALLIAN et numéro identification de la TVA.
                  <br/>Le n° de police RCP Galian est 120 137 405.
                  <br/>La tva intracommunautaire est le FR8382818043000013
                </p>
                <p><span class="blue-text"><strong>THE DOOR MAN</strong> </span> ne donne aucune
                  garantie, de quelque nature que ce soit, qu’elle soit expresse, implicite ou autre,
                  relative au contenu du Site et incluant sans s’y limiter que les informations
                  contenues sur le Site sont complètes, exactes, à jour ou qu’elles n’enfreignent pas
                  d’éventuels
                  droits de
                  tiers.<br><br><span class="blue-text"><strong>THE DOOR MAN</strong> </span> ne peut
                  en outre garantir l’accessibilité permanente au Site ou que le Site sera exempt de
                  toutes erreurs ou problèmes techniques, incluant tous virus notamment. <span
                    class="blue-text"><strong>THE DOOR MAN</strong> </span> fera ses meilleurs
                  efforts afin d’éviter
                  la
                  propagation de virus sur le Site, mais ne peut garantir leur absence et de ce fait
                  exclut toute responsabilité à cet égard. Il est recommandé aux utilisateurs de
                  prendre toutes mesures utiles de précaution afin de se protéger contre les virus
                  diffusés par Internet.</p>

              </div>
            </ng-template>
              </div>
            </div>
          </div>
          <div ngbAccordionItem>
            <h4 ngbAccordionHeader>
              <button ngbAccordionButton>MÉDIATION DE LA CONSOMMATION – RÈGLEMENT AMIABLE DES LITIGES</button>
            </h4>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
            <ng-template>
              <div>
                <p>Pour tout litige afférent à l’exécution du présent mandat, le mandant, s’il est un «
                  consommateur » au sens de l’article liminaire du code de la consommation, est
                  informé qu’il peut saisir le médiateur de la consommation par courrier postal à
                  l'attention de Madame/Monsieur le Médiateur de la Fédération Nationale de
                  l’Immobilier – FNAIM – 129
                  rue du Faubourg Saint Honoré – 75008 Paris.</p>
                <p>Dans l’hypothèse où le mandant n’a pas la qualité de consommateur, il a la
                  possibilité de saisir le Département Qualité de la FNAIM en se rendant sur le site
                  www.fnaim.fr</p>

              </div>
            </ng-template>
              </div>
            </div>
          </div>
          <div ngbAccordionItem>
            <h4 ngbAccordionHeader>
              <button ngbAccordionButton>Contact</button>
            </h4>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
            <ng-template>
              <div>
                <p>Vous pouvez nous contacter par l’intermédiaire de notre<a
                  [routerLink]="['/contact']" fragment="Nous-contacter"> formulaire de contact</a></p>
              </div>
            </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
